"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
const react_1 = require("react");
const theme_context_1 = require("./theme.context");
const useTheme = () => {
    const context = (0, react_1.useContext)(theme_context_1.ThemeContext);
    if (context) {
        return Object.assign({}, context);
    }
    throw new Error('Contexto de temas não está pronto');
};
exports.useTheme = useTheme;
